import { render, staticRenderFns } from "./peopleAddAnjianTemplate.vue?vue&type=template&id=5751a51d&scoped=true"
import script from "./peopleAddAnjianTemplate.vue?vue&type=script&lang=js"
export * from "./peopleAddAnjianTemplate.vue?vue&type=script&lang=js"
import style0 from "./peopleAddAnjianTemplate.vue?vue&type=style&index=0&id=5751a51d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751a51d",
  null
  
)

export default component.exports